import { Component, Inject, OnInit,OnDestroy, Output , EventEmitter} from '@angular/core';
import { Store } from '@src/store';
import { projectsActions } from "@src/store/reducers/projectsReducer";
import { userActions } from "@src/store/reducers/userReducer";


@Component({   
    selector: 'deployed-packages-details-filter',
    template: require('./deployed-details-packages-filter.component.html'),
    styles: [require('./deployed-details-packages-filter.component.scss')]
})
export class DeployedPackagesDetailsFilterComponent implements OnInit , OnDestroy {
  
    public projectGroups:any;
    public tag:string;
    public package:string;
    public selectedProjectGroup:any = 'Any Project';
    public user:string;
    public projects:any;
    public selectedProject:any = 'All';
    public unSubscribe: any;
    public unSubscribe2: any;
    public disableButton:boolean = false;
    public fromDate: Date = new Date();
    public toDate: Date = new Date();
    public isCustomDate: boolean = false;
    initFrom: boolean;
    initTo: boolean;
     @Output() public filter = new EventEmitter();
    constructor(private store: Store , @Inject('$state') private $stateParams: any  ){
     
    }


     public ngOnInit() {
        this.store.dispatch({
            type: projectsActions.GET_PROJECTS_WITH_DEPLOY_STATUS
        });
    
        this.store.dispatch({
            type: userActions.GET_PROJECT_GROUPS
        }); 

     this.unSubscribe = this.store.subscribe(__ => {
        if (this.store.getState().user.projectGroups) {
            const tempProjectGroups = this.store.getState().user.projectGroups;
            this.projectGroups = tempProjectGroups;
        }
    });
 
    
        this.unSubscribe2 = this.store.subscribe(__ => {
            if (this.store.getState().projects.projectWithDeployItems) {
                //this.selectedProject = 'All'
                const tempProjects =  this.store.getState().projects.projectWithDeployItems;
                this.projects = tempProjects;
                //sort projects so the first active one will be first
                if(!this.projects && tempProjects && tempProjects.length>0){
                    this.projects = __.filter(tempProjects, (item) => {
                        return !item.isDraft
                    }).sort(this.projectsSortByDateComparator);
                    if(!this.$stateParams.id){
                        this.selectedProject = this.projects[0];
                  
                    } 
                    else
                    {
                        this.selectedProject = this.projects.find(proj => proj.id == this.$stateParams.id);
                  
                    }
                    
                }
     
                if(this.projects && this.projects.length === 0)
                {
                    this.projects[0] = {}
                    this.disableButton  = true
                }
                else if(this.projects && this.projects.length !== 0 && !(this.projects.some(proj => proj.isAll )))
                {
                    this.disableButton  = false
                    let ids = this.projects.map(obj => obj.id)
                    this.projects = [
                        {
                            'id': ids,
                            'name': 'All',
                            isAll: true
                        },...this.projects]
                }
                
            }
        });
   


  

    }

    async setProjects() {
        this.projects = [];
        let projectGrp = this.projectGroups.find(x => x.name == this.selectedProjectGroup);
        await this.store.dispatch({
            type: userActions.GET_PROJECT_GROUP,
            payload: {
                projectGroupId: projectGrp.id
            }
        })
        projectGrp = this.store.getState().user.projectGroup;
            if (projectGrp.id != -1) {
                const tempProjects = this.store.getState().projects.projectWithDeployItems;
                this.projects = tempProjects.filter(project => {
                    if(!projectGrp.pipelineIds || projectGrp.pipelineIds.length === 0)
                        return false;
                    return projectGrp.pipelineIds.includes(project.id);
                })
                let ids = this.projects.map(obj => obj.id)
                if(this.projects.length === 0)
                {
                    this.projects[0] = {}
                    this.disableButton  = true
                }
                else if(this.projects.length !== 0)
                {
                    this.disableButton  = false
                    this.projects = [
                        {
                            'id': ids,
                            'name': 'All',
                            isAll: true
                        },...this.projects]
                }

            } 
 
     
      
    }


    ngOnDestroy() {
        this.unSubscribe();
        this.unSubscribe2();
    }

    public selectedTime(data: any): void {
        this.fromDate = new Date(data.value.fromDate);
        this.toDate = new Date(data.value.toDate);
        this.isCustomDate = data.name === 'Custom';
        if (this.isCustomDate) {
            this.initFrom = false;
            this.initTo = false;
        }
    }


    projectsSortByDateComparator(proj1,proj2) {
        if (proj1.isDraft && proj2.isDraft == false) {
            return 1;
        } else if (proj1.isDraft == false && proj2.isDraft) {
            return -1;
        }
        if (proj1.lastActivity != null && proj2.lastActivity != null) {
            let firstDate = new Date(proj1.lastActivity);
            let secondDate = new Date(proj2.lastActivity);
            if (firstDate.getTime() > secondDate.getTime()) {
                return -1;
            } else if (firstDate.getTime() < secondDate.getTime()) {
                return 1;
            } else {
                return 0;
            }
        }
        if (proj1.lastActivity != null && proj2.lastActivity == null) {
            return -1;
        }
        if (proj1.lastActivity == null && proj2.lastActivity != null) {
            return 1;
        }
        return proj1.name.localeCompare(proj2.name);
    }
    public onFilter(): void {
    let projectSelectedObj= null
    if(this.selectedProject != null){
        projectSelectedObj = this.projects.find(x => x.name === this.selectedProject)
    }

    this.filter.emit({data: {isManualSorting: false,
     project:  projectSelectedObj ,
     fromDate:this.fromDate,
     toDate:this.toDate,
     tag :this.tag,
     package :this.package,
     fromFilter : true,
     user:this.user}});
  
 }  

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/reports/deployed-packages-details/deployed-packages-details-filter/deployed-details-packages-filter.component.ts